import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6">
        <div className="max-w-7xl mx-auto text-center">
          {/* Top Badge */}
          <div className="inline-flex items-center gap-2 px-5 py-2 bg-white rounded-full shadow-sm mb-8">
            <i className="ri-cup-line text-[#C17855] text-lg"></i>
            <span className="text-sm font-medium text-[#3D2817]">Established in Otley</span>
          </div>
          
          {/* Main Headline */}
          <h1 className="text-6xl md:text-7xl font-serif font-bold text-[#3D2817] mb-6 leading-tight">
            Welcome to<br />
            <span className="text-[#C17855]">The Bridge Street Café</span>
          </h1>
          
          {/* Subheading */}
          <p className="text-xl text-gray-600 mb-10 max-w-2xl mx-auto font-light">
            Your local spot for great coffee, homemade food, and friendly faces
          </p>
          
          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Link 
              to="/contact" 
              className="px-8 py-4 bg-[#C17855] text-white rounded-full font-medium hover:bg-[#A66545] transition-colors whitespace-nowrap cursor-pointer shadow-lg"
            >
              Visit Us Today
            </Link>
            <Link 
              to="/menu" 
              className="px-8 py-4 bg-white text-[#C17855] border-2 border-[#C17855] rounded-full font-medium hover:bg-[#C17855] hover:text-white transition-colors whitespace-nowrap cursor-pointer"
            >
              View Our Menu
            </Link>
          </div>
          
          {/* Opening Hours */}
          <div className="inline-flex items-center gap-3 px-6 py-3 bg-white rounded-full shadow-sm">
            <i className="ri-time-line text-[#C17855] text-xl"></i>
            <span className="text-sm font-medium text-[#3D2817]">
              Mon-Sat 8am-5pm | Sun 9am-4pm
            </span>
          </div>
        </div>
        
        {/* Hero Image */}
        <div className="max-w-6xl mx-auto mt-16">
          <div className="rounded-t-3xl overflow-hidden shadow-2xl" style={{ height: '500px' }}>
            <img 
              src="https://public.readdy.ai/ai/img_res/14e1654075d6be56de9394b4379f1227.jpg" 
              alt="The Bridge Street Café Interior" 
              className="w-full h-full object-cover object-center"
            />
          </div>
        </div>
      </section>

      {/* What Makes Us Special Section */}
      <section className="py-20 px-6 bg-[#F5F3F0]">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-5xl font-bold text-center mb-4 text-[#3D2817]">
            What Makes Us <span className="text-[#C17855]">Special</span>
          </h2>
          <p className="text-center text-gray-600 mb-16 text-lg">Discover why locals love The Bridge Street Café</p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Large Left Card */}
            <div className="md:row-span-2 relative rounded-3xl overflow-hidden shadow-lg" style={{ height: '600px' }}>
              <img 
                src="https://readdy.ai/api/search-image?query=Community%20cafe%20gathering%20people%20chatting%20laughing%20together%20friendly%20atmosphere%20local%20customers%20meeting%20friends%20warm%20welcoming%20environment%20British%20cafe%20culture%20neighborhood%20hub%20social%20space&width=600&height=600&seq=cafe-community-hub-002&orientation=squarish" 
                alt="Community Hub" 
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-8">
                <div className="flex items-center gap-3 mb-2">
                  <i className="ri-community-line text-white text-3xl"></i>
                  <h3 className="text-3xl font-bold text-white">Community Hub</h3>
                </div>
                <p className="text-white/90 text-lg">A welcoming space where neighbours become friends</p>
              </div>
            </div>
            
            {/* Top Right Card */}
            <div className="bg-[#C4D4C0] rounded-3xl p-10 flex flex-col justify-center items-center text-center shadow-lg" style={{ height: '290px' }}>
              <div className="w-20 h-20 flex items-center justify-center mb-6">
                <i className="ri-seedling-line text-[#C17855] text-6xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#3D2817] mb-3">Locally Sourced</h3>
              <p className="text-gray-700">Fresh ingredients from Yorkshire suppliers we trust</p>
            </div>
            
            {/* Bottom Right Card */}
            <div className="bg-[#F4D4C8] rounded-3xl p-10 flex flex-col justify-center items-center text-center shadow-lg" style={{ height: '290px' }}>
              <div className="w-20 h-20 flex items-center justify-center mb-6">
                <i className="ri-heart-3-line text-[#C17855] text-6xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-[#3D2817] mb-3">Made with Love</h3>
              <p className="text-gray-700">Every dish prepared fresh daily with care and attention</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-6 bg-[#FAF7F2]">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-4">
            <div className="inline-flex items-center gap-2 px-5 py-2 bg-[#C17855] text-white rounded-full mb-4">
              <i className="ri-star-fill text-lg"></i>
              <span className="text-sm font-medium">What Our Customers Say</span>
            </div>
          </div>
          <h2 className="text-5xl font-bold text-center mb-16 text-[#3D2817]">
            Loved by Our Community
          </h2>
          
          {/* First Row - Three Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
            {/* Card 1 */}
            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-14 h-14 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                  <i className="ri-user-smile-line text-2xl text-[#C17855]"></i>
                </div>
                <div>
                  <p className="font-bold text-[#3D2817]">Sarah M.</p>
                  <p className="text-sm text-gray-600">Otley Resident</p>
                </div>
              </div>
              <div className="text-6xl text-[#C17855]/20 mb-4">"</div>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Absolutely brilliant. Best flat white in town and the staff always remember my order.
              </p>
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-lg"></i>
                ))}
              </div>
            </div>
            
            {/* Card 2 */}
            <div className="bg-white rounded-3xl p-8 shadow-lg">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-14 h-14 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                  <i className="ri-user-smile-line text-2xl text-[#C17855]"></i>
                </div>
                <div>
                  <p className="font-bold text-[#3D2817]">James T.</p>
                  <p className="text-sm text-gray-600">Regular Customer</p>
                </div>
              </div>
              <div className="text-6xl text-[#C17855]/20 mb-4">"</div>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Great coffee and a lovely atmosphere. A regular stop for us now.
              </p>
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-lg"></i>
                ))}
              </div>
            </div>
            
            {/* Card 3 - Image Card */}
            <div className="relative rounded-3xl overflow-hidden shadow-lg" style={{ height: '350px' }}>
              <img 
                src="https://readdy.ai/api/search-image?query=Happy%20smiling%20male%20customer%20holding%20coffee%20cup%20in%20cafe%20wearing%20casual%20clothing%20friendly%20expression%20satisfied%20customer%20enjoying%20hot%20beverage%20portrait%20natural%20lighting%20Britain%20UK%20style&width=400&height=350&seq=cafe-customer-mark-003&orientation=portrait" 
                alt="Mark D." 
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <p className="font-bold text-white text-lg">Mark D.</p>
                <p className="text-sm text-white/90">Local Business Owner</p>
              </div>
            </div>
          </div>
          
          {/* Second Row - Two Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* Wide Card */}
            <div className="md:col-span-2 relative rounded-3xl overflow-hidden shadow-lg" style={{ height: '280px' }}>
              <img 
                src="https://readdy.ai/api/search-image?query=Happy%20family%20with%20children%20in%20cafe%20enjoying%20hot%20chocolate%20and%20cakes%20smiling%20parents%20with%20kids%20relaxed%20weekend%20atmosphere%20cozy%20British%20cafe%20family%20friendly%20environment%20warm%20welcoming%20space&width=800&height=280&seq=cafe-family-emma-004&orientation=landscape" 
                alt="Emma & Family" 
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#3D2817]/90 to-transparent p-8">
                <p className="font-bold text-white text-xl mb-1">Emma & Family</p>
                <p className="text-sm text-white/90 mb-3">Weekend Regulars</p>
                <p className="text-white/95 mb-3 leading-relaxed">
                  Our Sunday morning tradition. The kids love the hot chocolate and we love the homemade cakes.
                </p>
                <div className="flex gap-1">
                  {[...Array(4)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                  <i className="ri-star-line text-yellow-400 text-lg"></i>
                </div>
              </div>
            </div>
            
            {/* Stacked Mini Cards */}
            <div className="flex flex-col gap-6">
              <div className="bg-white rounded-3xl p-6 shadow-lg flex-1">
                <div className="text-4xl text-[#C17855]/20 mb-3">"</div>
                <p className="text-gray-700 text-sm mb-4 leading-relaxed">
                  Lovely spot for a quiet read with excellent coffee
                </p>
                <div className="flex items-center justify-end gap-2">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                    <i className="ri-user-smile-line text-lg text-[#C17855]"></i>
                  </div>
                  <p className="text-sm font-bold text-[#3D2817]">David R.</p>
                </div>
              </div>
              
              <div className="bg-white rounded-3xl p-6 shadow-lg flex-1">
                <div className="text-4xl text-[#C17855]/20 mb-3">"</div>
                <p className="text-gray-700 text-sm mb-4 leading-relaxed">
                  Best breakfast in Otley, hands down
                </p>
                <div className="flex items-center justify-end gap-2">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center">
                    <i className="ri-user-smile-line text-lg text-[#C17855]"></i>
                  </div>
                  <p className="text-sm font-bold text-[#3D2817]">Lisa K.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Visit Us CTA Section */}
      <section className="py-20 px-6 bg-[#FAF7F2]">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-6xl font-bold text-[#3D2817] mb-6">
            Ready to <span className="text-[#C17855]">Visit?</span>
          </h2>
          <p className="text-xl text-gray-600 mb-10 font-light">
            We're located in the heart of Otley, just a short walk from the town centre
          </p>
          <Link 
            to="/contact" 
            className="inline-flex items-center gap-3 px-10 py-5 bg-[#C17855] text-white rounded-full font-medium hover:bg-[#A66545] transition-colors whitespace-nowrap cursor-pointer shadow-xl text-lg"
          >
            Get Directions
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>
        
        <div className="max-w-6xl mx-auto mt-16">
          <div className="rounded-3xl overflow-hidden shadow-2xl" style={{ height: '350px' }}>
            <img 
              src="https://readdy.ai/api/search-image?query=Charming%20British%20cafe%20exterior%20storefront%20with%20welcoming%20entrance%20outdoor%20seating%20area%20traditional%20shop%20front%20Yorkshire%20town%20street%20view%20Bridge%20Street%20Otley%20West%20Yorkshire%20quaint%20local%20business%20brick%20building%20inviting%20facade&width=1200&height=350&seq=cafe-exterior-storefront-005&orientation=landscape" 
              alt="The Bridge Street Café Exterior" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}